import RevenueEstimateCard from '../../../../components/RevenueEstimateCard/RevenueEstimateCard';
import { DEFAULT_AVAILABILITY, resolveListingAvailability } from '../../../../utils/availabilitySchedule';

function resolveGeoSpaceCount(listing) {
    const gsc = listing.geoSpaceCount;
    if (gsc == null) return null;
    if (typeof gsc === 'number') return gsc;
    return gsc.suggestedCount ?? null;
}

export default function RevenueEstimateSection({
    listing,
    editMode = false,
    dirtyFields,
}) {
    const geoCount = resolveGeoSpaceCount(listing);
    const spots = editMode && dirtyFields
        ? dirtyFields.maxSpots
        : (listing.pricing?.maxSpots ?? geoCount);
    const hourlyRate = listing.pricing?.hourlyRate;
    // Prefer the host's live-edit availability, then the persisted schedule.
    // resolveListingAvailability returns DEFAULT_AVAILABILITY for listings
    // created before availability was captured, so the card never disappears
    // for legacy listings.
    const availability = (editMode && dirtyFields?.availability)
        || resolveListingAvailability(listing)
        || DEFAULT_AVAILABILITY;

    return (
        <div className="host-panel-section">
            <RevenueEstimateCard
                spots={spots}
                hourlyRate={hourlyRate}
                availability={availability}
            />
        </div>
    );
}
